export default __webpack_public_path__ + "static/media/tech_landing_bg-860x486.4b760d85.jpg";